import QAQuestion from './QAQuestion';
import { computed, makeObservable } from 'mobx';
import _ from 'lodash';

class QuizQuestion extends QAQuestion {
  constructor(other) {
    super();

    makeObservable(this, {
      quizCorrectOption: computed
    });
    this.merge(other);
  }

  get quizCorrectOption() {
    return _.find(this.options, option => _.get(option, 'answer'));
  }
}

export default QuizQuestion;
